(() => {
  const DESKTOP_MIN = 990;

  function isDesktop() {
    return window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;
  }

  function init() {
    // Scope only to the header inline menu, not every <details> on the page
    const headerMenu = document.querySelector('.header__inline-menu');
    if (!headerMenu) return;

    // Only header dropdown <details>
    const dropdowns = headerMenu.querySelectorAll('details');
    if (!dropdowns.length) return;

    // One outside-click handler (not one per dropdown)
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      dropdowns.forEach((d) => {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });

    dropdowns.forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      // Only if it really has a submenu
      const submenu =
        details.querySelector('.header__submenu') ||
        details.querySelector('[class*="submenu"]') ||
        details.querySelector('ul');

      if (!submenu) return;

      let closeTimer;

      const open = () => {
        if (!isDesktop()) return;
        dropdowns.forEach((d) => {
          if (d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
      };

      const close = () => {
        if (!isDesktop()) return;
        details.removeAttribute('open');
      };

      details.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        open();
      });

      details.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 120);
      });

      // Desktop: prevent click-toggle so hover is primary behavior
      summary.addEventListener('click', (e) => {
        if (!isDesktop()) return; // mobile keeps normal tap behavior
        e.preventDefault();
        open();
      });
    });
  }

  // Run now if already loaded, otherwise on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();